(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stappenplan"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('steps-section')) {
    class StepsSection extends HTMLElement {
      connectedCallback() {
        this.mobileDescriptionBehavior = this.dataset.mobileDescriptionBehavior;
        this.cards = [...this.querySelectorAll('[data-steps-card]')];

        if (this.mobileDescriptionBehavior !== 'tap_to_expand') return;

        this.cards.forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
            this.toggleCard(card);
          });

          card.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            this.toggleCard(card);
          });
        });
      }

      toggleCard(activeCard) {
        this.cards.forEach((card) => {
          const isActive = card === activeCard ? !card.classList.contains('is-active') : false;
          card.classList.toggle('is-active', isActive);
          card.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('steps-section', StepsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
